import { Injectable } from '@angular/core';

import { Action, select, Store } from '@ngrx/store';

import * as fromLocations from './locations.reducer';
import * as LocationsSelectors from './locations.selectors';

@Injectable()
export class LocationsFacade {
  loaded$ = this.store.pipe(select(LocationsSelectors.getLocationsLoaded));
  allLocations$ = this.store.pipe(select(LocationsSelectors.getAllLocations));
  selectedLocation$ = this.store.pipe(
    select(LocationsSelectors.getLocationSelected)
  );

  paginatedData$ = this.store.pipe(
    select(LocationsSelectors.getLocationPagination)
  );

  administrators$ = this.store.pipe(
    select(LocationsSelectors.getLocationAdministrators)
  );
  roles$ = this.store.pipe(select(LocationsSelectors.getLocationRoles));
  selectedAdministrator$ = this.store.pipe(
    select(LocationsSelectors.getSelectedAministrator)
  );

  nextPage$ = this.store.pipe(select(LocationsSelectors.getLocationsNextPage));

  constructor(private store: Store<fromLocations.LocationsPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
